export default {"src":"/_next/static/media/moment-letter.cc3158cc.svg","height":151,"width":183,"blurWidth":0,"blurHeight":0};